//node_modules
import React, { FunctionComponent } from "react";
import { Container, Button } from "react-bootstrap";

//components
import NextLink from "@adjust/website/src/components/NextLink";
import StaticBackgroundComponent from "@adjust/website/src/components/StaticBackgroundComponent";

//images
import bgImage from "@adjust/public/images/e14928f047b58720d574e7034b54326b.png";

//styles
import { cx, css } from "@adjust/libs/emotion";
import { BREAKPOINTS } from "@adjust/website/src/styles/shared";

const href = "https://www.sandals.com/?referral=122840&agentid=STGR7206";

const header = css({
  color: "white",
  fontFamily: "Domine, sans-serif",
  fontSize: "2.5rem",
  textAlign: "center",
  textShadow: "2px 2px black",
  [BREAKPOINTS.md]: {
    fontSize: "3rem",
  },
  [BREAKPOINTS.lg]: {
    fontSize: "3.5rem",
  },
});

const wrapper = css({
  overflow: "hidden",
  borderRadius: "20px",
});

const container = css({
  margin: "16px 16px 256px 16px",
  [BREAKPOINTS.md]: {
    margin: "16px 16px 394px 16px",
  },
  [BREAKPOINTS.lg]: {
    margin: "64px 16px 512px 16px",
  },
});

const button = css({
  boxShadow: "2px 2px black",
});

const SandalsPage: FunctionComponent<any> = () => {
  return (
    <div className={cx(wrapper, "mt-5")}>
      <StaticBackgroundComponent bgImage={bgImage} bgImageAlt="Sandals Resort" quality={80} fetchPriority="high">
        <Container className="my-5">
          <div className={container}>
            <h2 className={header}>Explore a New Kind of Paradise</h2>
            <div className="text-center my-3">
              <Button as="a" variant="success" className={cx(button, "text-uppercase")} rel="noopener nofollow" target="_blank" size="lg" href={href}>
                Look Closer Here!
              </Button>
            </div>
          </div>
        </Container>
      </StaticBackgroundComponent>
    </div>
  );
};

export default React.memo(SandalsPage);
